import {Injectable} from '@angular/core';

import {AuthenticationService} from './index';
import {LoginHelper} from '../helpers';
import {Subject} from "rxjs";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class RecommendedSolutionService {
  constructor(public http: HttpClient,
              public config: IndexConfigService) {
  }

  public url(method: string, id: number = undefined, submethod: string = undefined) {
    let url = this.config.api + '/api/' + method;
    if (id) url += '/' + id;
    if (submethod) url += '/' + submethod;
    return url;
  }

  getAll() {
    return this.http.get<any>(this.url('recommendedSolutions'));
  }
  getRecommendedSolutions(controlItemId) {
    return this.http.get<any>(this.url('recommendedSolutions', controlItemId));
  }
  deleteRecommendedSolution(recommendedSolutionId: number) {
    return this.http.delete<any>(this.url('recommendedSolution', recommendedSolutionId));
  }

  saveRecommendedSolution(recommendedSolution: any) {
    return this.http.post<any>(this.url('recommendedSolution'), recommendedSolution);
  }
  upload(entity: File, name: string) {
    let formData = new FormData();
    formData.append(entity.name, entity, name);
    return this.http.post<any>(this.url('recommendedSolution/upload'), formData);
  }
  deleteList(listId) {
    return this.http.delete<any>(this.url('recommendedSolutionsList', listId));
  }
  saveList(list) {
    return this.http.post<any>(this.url('recommendedSolutionsList'), list);
  }

  addReference(itemId, controlItemId) {
    return this.http.post<any>(this.url('recommendedSolution/references', itemId, controlItemId), {})
  }

  removeReference(referenceId) {
    return this.http.delete<any>(this.url('recommendedSolution/references', referenceId))
  }

  @Load()
  uploadLogo(logo: File) {
    let formData = new FormData();

    formData.append(logo.name, logo);

    return this.http
      .post<any>(this.config.api + '/api/recommendedSolutionsList/image', formData);
  }
}
